import React from 'react'
import Link from 'next/link'
import { Card } from 'plume-ui'
import { roundDetailUrl } from '@/lib/url'
import { PastInvestment } from '../../../types'
import { A } from '../../atoms/A'
import { CardInnerTitle } from '../../atoms/CardInnerTitle'
import { Table, TableCell, TableHeading } from '../../atoms/Table'
import { formatWithComma } from '@/lib/number'
import { EmptyCard } from '../../common/EmptyCard'
import { FormattedDate } from '../../atoms/FormattedDate'

type Props = {
  list: PastInvestment[]
  className?: string
}

const unlinkableInvestorTypes = ['*創業者*', '*不明*', '*個人*', '*従業員*']
const unlinkableFundTypes = ['*創業者*', '*不明*', '*個人*']

export const PastInvestments: React.FC<Props> = (props) => {
  return (
    <Card className={props.className}>
      <CardInnerTitle title="ラウンド明細（移動前所有）一覧" />
      {props.list.length > 0 ? (
        <Table className="startup-previous-investment-table">
          <thead>
            <tr>
              <TableHeading>明細行</TableHeading>
              <TableHeading>年月日</TableHeading>
              <TableHeading>スタートアップ</TableHeading>
              <TableHeading>投資家名</TableHeading>
              <TableHeading>ファンド名</TableHeading>
              <TableHeading sub="円">株価</TableHeading>
              <TableHeading>株数</TableHeading>
              <TableHeading sub="千円">投資額</TableHeading>
              <TableHeading>備考</TableHeading>
            </tr>
          </thead>
          <tbody>
            {props.list.map((investment, i) => (
              <tr key={i}>
                <TableCell>
                  <A
                    href={roundDetailUrl(
                      investment.company.shortname,
                      investment.shortname
                    )}
                    decoration="none"
                    target="_blank"
                  >
                    {investment.shortname}
                  </A>
                </TableCell>
                <TableCell>
                  <FormattedDate>{investment.date}</FormattedDate>
                </TableCell>
                <TableCell>
                  <A
                    href={investment.company.path}
                    decoration="none"
                    target="_blank"
                  >
                    {investment.company.name}
                  </A>
                </TableCell>
                <TableCell>
                  {unlinkableInvestorTypes.includes(
                    investment.investor.name
                  ) ? (
                    investment.investor.name
                  ) : (
                    <Link
                      href={`/investors?shortname=${investment.investor.shortname}`}
                      as={`/investors/${investment.investor.shortname}`}
                    >
                      <A decoration="none">{investment.investor.name}</A>
                    </Link>
                  )}
                </TableCell>
                <TableCell className="fund-name">
                  {unlinkableFundTypes.includes(investment.fund.name) ? (
                    investment.fund.name
                  ) : (
                    <A
                      href={`/investors/${investment.investor.shortname}/funds/${investment.fund.shortname}`}
                      decoration="none"
                    >
                      {investment.fund.name}
                    </A>
                  )}
                </TableCell>
                <TableCell>
                  {investment.price &&
                    formatWithComma(investment.price, { decimalPlace: 1 })}
                </TableCell>
                <TableCell>
                  {investment.numOfStocks &&
                    formatWithComma(investment.numOfStocks, {
                      decimalPlace: 2,
                    })}
                </TableCell>
                <TableCell>
                  {investment.amount && formatWithComma(investment.amount)}
                </TableCell>
                <TableCell>{investment.remark}</TableCell>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <EmptyCard />
      )}
    </Card>
  )
}
